import '../css/home.css';
import React from 'react';
import { PublicNavbar, PublicFooter, ParticleBackground } from '../components/pagestyle.js';
import { Register } from '../components/header.js';

import { AliceChat } from './alice.js';
import { useState, useEffect, useRef } from "react";
import {
    Routes,
    Route,
    Link,
    Navigate,
    useLocation,
    useParams,
    useNavigate
} from "react-router-dom";
import Typed from 'typed.js';
import { GradientAnimation } from '../components/pagestyle.js';
import { ScrollToHashElement } from '../components/pagestyle.js';
import Carousel from 'react-material-ui-carousel'
import { useMediaQuery, useTheme } from '@mui/material';
import D3DynamicLine from '../d3Charts/d3DynamicLine.js';
import { TickerOfTheDay } from '../components/marketpulseComponents/TickerOfTheDay.js';
import imagePaths from './names.json'


/** animate one element from 0 → target over `duration` ms */
function countUp(el, target, duration = 500) {
    const start = performance.now();
    el.classList.add("visible");
    const tick  = now => {
      const t = Math.min((now - start) / duration, 1);        // 0 → 1
      const val = Math.round(t * target);
      el.textContent = val ? val.toLocaleString() : "...";
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
}

/* animation helper for the stats numbers to pop up increasingly  */
/*  OLD ANIMATION -> SMALL BUG WITH THE SCROLL  */
// function usePopInStatsNumbers() {
//     const fired = useRef(false);            // guarantees “once only”
  
//     useEffect(() => {
//       const block = document.querySelector(".home-stat");
//       if (!block) return;
  
//       const stats = block.querySelectorAll(".home-stat-h3");
//       let nextDelay = 0;
  
//       /* ---- what to do when we finally trigger ---- */
//       const runAnimation = () => {
//         if (fired.current) return;
//         fired.current = true;
  
//         stats.forEach((el) => {
//           const num = Number(el.textContent.replace(/,/g, ""));
//           if (!Number.isNaN(num)) {
//             setTimeout(() => countUp(el, num), nextDelay);
//             nextDelay += 300;
//           }
//         });
  
//         observer.disconnect();
//         window.removeEventListener("scroll", hardCheck);
//       };
  
//       /* ---- IntersectionObserver (nice path) ---- */
//       const observer = new IntersectionObserver(
//         ([entry]) => {
//           if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
//             runAnimation();
//           }
//         },
//         { threshold: [0, 0.35] }            // fire at 0 and 0.35
//       );
//       observer.observe(block);
  
//       /* ---- hard-check fallback (fast scroll) ---- */
//       const hardCheck = () => {
//         const rect = block.getBoundingClientRect();
//         const blockVisible = window.innerHeight - rect.top;
//         const needed = rect.height * 0.35;  // 35 % of own height
//         if (blockVisible > needed) runAnimation();
//       };
  
//       window.addEventListener("scroll", hardCheck, { passive: true });
//       hardCheck();                          // run once in case we already passed
  
//       return () => {
//         observer.disconnect();
//         window.removeEventListener("scroll", hardCheck);
//       };
//     }, []);
// }


function usePopInStatsNumbers() { // Pass countUp as a prop if it's not global
  const fired = useRef(false); // This will be false on every new mount
  const observerRef = useRef(null); // Ref to store the observer instance
  const hardCheckListenerRef = useRef(null); // Ref to store the hardCheck function reference

  useEffect(() => {
    // Reset fired status when the component mounts (or re-mounts after navigation)
    fired.current = false;

    const block = document.querySelector(".home-stat");
    if (!block) {
        // console.warn("home-stat block not found. Animation won't run.");
        return;
    }

    const stats = block.querySelectorAll(".home-stat-h3");
    let nextDelay = 0; // This will reset on each mount

    const runAnimation = () => {
      if (fired.current) return; // Prevent re-running if already fired in this mount cycle
      fired.current = true;

      stats.forEach((el) => {
        const num = Number(el.textContent.replace(/,/g, ""));
        if (!Number.isNaN(num)) {
          setTimeout(() => countUp(el, num), nextDelay); // Use the passed function
          nextDelay += 300;
        }
      });

      // Disconnect observer and remove listener only after animation runs
      // This ensures they don't trigger multiple times
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null; // Clear the ref
      }
      if (hardCheckListenerRef.current) {
        window.removeEventListener("scroll", hardCheckListenerRef.current);
        hardCheckListenerRef.current = null; // Clear the ref
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          runAnimation();
        }
      },
      { threshold: [0, 0.35] }
    );

    observerRef.current = observer; // Store observer in ref
    observer.observe(block);

    const hardCheck = () => {
      // Only run hardCheck if the animation hasn't fired yet
      if (fired.current) {
          window.removeEventListener("scroll", hardCheckListenerRef.current);
          hardCheckListenerRef.current = null;
          return;
      }
      const rect = block.getBoundingClientRect();
      const blockVisible = window.innerHeight - rect.top;
      const needed = rect.height * 0.35;
      if (blockVisible > needed) runAnimation();
    };

    hardCheckListenerRef.current = hardCheck;
    window.addEventListener("scroll", hardCheck, { passive: true });
    hardCheck();

    // Cleanup function: This runs when the component unmounts
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
      if (hardCheckListenerRef.current) {
        window.removeEventListener("scroll", hardCheckListenerRef.current);
      }
      // Reset fired.current for the *next* time this hook is used if it's
      // part of a persistent element that doesn't unmount (less common for this scenario)
      fired.current = false; // Ensures it's false for subsequent mounts if any weirdness occurs
    };
  });
}

export function HomeStatisticsSection() {
    const [statistics, setStatistics] = useState(null);

    useEffect(() => {
        fetch("/api/public/homepage_statistics")
            .then((response) => response.json())
            .then((json) => setStatistics(json));
    }, []);

    function formatNumber(num) {
        // add commas
        return num ? num.toLocaleString() : "..."
    }

    usePopInStatsNumbers();

    return (
        <div className="home-stat">
            <div className="home-stat-holder">
                <div className="home-stat">
                    <p className="home-stat-p">Active Companies and ETFs</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.debtorCount) : "..."}
                    </h3>
                </div>
                <div className="home-stat">
                    <p className="home-stat-p">Daily Signals</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.signalCount) : "..."}
                    </h3>
                </div>
                <div className="home-stat">
                    <p className="home-stat-p">Financial Ratios</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.financialRatios) : "..."}
                    </h3>
                </div>
                <div className="home-stat">
                    <p className="home-stat-p">Monthly Insider Activity</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.insiderTradingUpdates) : "..."}
                    </h3>
                </div>
                <div className="home-stat">
                    <p className="home-stat-p">Daily Sentiment Scores</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.ssCount) : "..."}
                    </h3>
                </div>
                <div className="home-stat">
                    <p className="home-stat-p">Daily News Articles</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.articleCount) : "..."}
                    </h3>
                </div>
                <div className="home-stat">
                    <p className="home-stat-p">Actively Covered Analysts</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.analysts) : "..."}
                    </h3>
                </div>
                <div className="home-stat">
                    <p className="home-stat-p">Relative Value Pairs</p>
                    <h3 className="home-stat-h3">
                        {statistics ? formatNumber(statistics.reValPairs) : "..."}
                    </h3>
                </div>
            </div>
        </div>
    );
}


const HomeSourcesSection = () => {

    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;

        const scrollSpeed = 2; // Pixels per interval
        const interval = setInterval(() => {
            container.scrollLeft += scrollSpeed;
            if (container.scrollLeft >= container.scrollWidth - container.offsetWidth - 1) {
                container.scrollLeft = 80;  // Move a bit to the left to match the tail position in the infinite loop
            }
        }, 20);

        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            {/* Title Section */}
            <h2 style={{ marginBottom: "20px", fontSize: "1.5rem", fontWeight: "bold" }}>
                Data from thousands of sources, including:
            </h2>
            <div
                ref={containerRef}
                style={{
                    height: "200px",
                    width: "80%",
                    display: "flex",
                    overflowX: "hidden",
                    overflowY: "hidden",
                    whiteSpace: "nowrap",
                    border: "0px solid black",  // 1px
                    borderRadius: "15px",
                    position: "relative",
                    zIndex: 0,
                    margin: "0 auto"
                }}
            >
                {imagePaths.map((imagePath, index) => (
                    <img
                        key={index}
                        src={imagePath}
                        alt={`Source: ${imagePath}`}
                        style={{
                            display: "inline-block",
                            height: "125px",
                            width: "auto",
                            marginRight: "50px",
                            border: "0px solid lightgray", // 1px
                            borderRadius: "10px",
                            backgroundColor: "transparent", // backgroundColor: "white",
                        }}
                    />
                ))}
            </div>
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 1) 100%)",
                    pointerEvents: "none",
                    zIndex: 1
                }}
            ></div>
        </div>
    );
};


function usePopInOnScroll() {
    useEffect(() => {
      // observe both the video and the text blocks
      const items = document.querySelectorAll(
        ".cropped-vid-container, .text-from-vid-container"
      );
  
      /**
       * IntersectionObserver:
       *   fires when at least 65 % is visible
       */
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const { isIntersecting, intersectionRatio, boundingClientRect } = entry;
  
            if (isIntersecting && intersectionRatio >= 0.65){
              // 65% in view → ADD the class
              entry.target.classList.add("visible");
            }

            if (!isIntersecting) {
              // fully out of view →  REMOVE the class
              entry.target.classList.remove("visible");
            }
          });
        },
        {
          threshold: [0.65], // fire at 65 %
        }
      );
  
      items.forEach(el => observer.observe(el));
      return () => observer.disconnect(); // cleanup on component unmount
    }, []);
  }

function HomePagesDisplay() {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    var subdomain = "";
    if (window.location.hostname.includes("researchdemo")) {
        subdomain = "researchdemo."
    }

    var subdomain = "";
    if (window.location.hostname.includes("researchdemo")) {
        subdomain = "researchdemo."
    }
    var api_url = `https://${subdomain}falpha.ai/api`
    if (window.location.hostname.includes("localhost")) {
        api_url = `http://localhost:3001/api`
    }
    const handleSignUp = (e) => {
        e.stopPropagation();
        window.location = `${api_url}/sign-up`;
    };


    /* LISTENERS FOR ROWS' EFFECTS */
    usePopInOnScroll();

    return (
        <div style={{ width: "100vw", overflowX: "hidden" }}>

            <br></br>
            <br></br>
            {/* <div style={{ width: "fit-content", maxWidth: "90%", margin: "auto" }} onClick={("Yes" == localStorage.getItem("user-is-logged-in-bam-money")) ? null : handleSignUp}>
                <TickerOfTheDay />
            </div> */}

            {/* <div className="home-display-page dark" style={{ marginBottom: 0, padding: "20px" }}>
                <div>
                    <h1 style={{color: "white"}}>Alpha-Enhancing Use Cases</h1>
                    <h3 style={{ width: "60%", margin: "auto", color: "white"}}>Enhance your trading, analytical and hedging strategies with tailored AI models and integrated data. Our solution combines traditional and alternative data sources for insights into insider trading, unbiased sentiment analysis, and more.</h3>
                </div>
            </div> */}


            {/* <div className="home-display-page dark" style={{ height: "fit-content", marginBottom: "40px" }}>
                <div className="home-display-cols">
                    <div style={{ flexBasis: "100%", margin: "0 20px" }}>
                        <img src="/images/home-icon-2.png" alt="" width="20%" style={{ filter: "brightness(0) invert(1)"}} />
                        <h2 style={{color: "white"}}>Top Relative Value</h2>
                        <h4 style={{color: "white"}}>Companies are ranked by <strong style={{ color: "black"}}>future risk-return performance</strong>. Choose from 100+ trading strategies.</h4>
                    </div>
                    <div style={{ flexBasis: "100%", margin: "0 20px" }}>
                        <img src="/images/home-icon-3.png" alt="" width="20%" style={{ filter: "brightness(0) invert(1)"}} />
                        <h2 style={{color: "white"}}>Optimal Hedges & Portfolios</h2>
                        <h4 style={{color: "white"}}>Compare ETFs, portfolios, and new recommendations. Discover <strong style={{ color: "black"}}>natural hedges</strong>.</h4>
                    </div>
                    <div style={{ flexBasis: "100%", margin: "0 20px" }}>
                        <img src="/images/home-icon-1.png" alt="" width="20%" style={{ filter: "brightness(0) invert(1)"}} />
                        <h2 style={{color: "white"}}>Improved Analytics Allocation</h2>
                        <h4 style={{color: "white"}}>Data insights to help you target corporations <strong style={{ color: "black"}}>primed for</strong> price <strong style={{ color: "black" }}>action</strong>.</h4>
                    </div>
                    <h1 className="home-display-h1">
                    <strong>“Past performance doesn't guarantee future results,”</strong><br />
                    <em className="orange" style={{ fontSize: "80px" }}>BUT</em><br />
                    <span style={{ fontSize: "25px" }}>our risk model gives you credit and equity predictions with confidence levels that outperform the market with precise trades (and we can prove it).</span><br />
                </h1>
                </div>
            </div> */}

            <div className="home-display-page" style={{ height: "fit-content", marginBottom: "20px" }}>
                <div>
                    <h1>Why use fAlpha?</h1>
                </div>
                <br />
                <br />
                <div className="home-display-grid">
                    <div className = 'cropped-vid-container allSides'>
                        <img className="cropped-vid" alt="" src="/images/NEWTP.gif" />
                    </div>
                    <div className='text-from-vid-container left'>
                        <h1 className='h1-section'>Essential Trade Predictions</h1>
                        <div className = "line"></div>
                        <p><b>Be ahead of the market. fAlpha provides signals for thousands of companies and ETFs, so your firm can get accurate pictures on trade decisions, find the company which optimally hedges your portfolio, or find a company in an industry which you should be wary of in under a minute.</b></p>
                        {/* <button
                                style={{
                                    padding: "0.75rem 1.5rem",
                                    color: "black",
                                    border: "2px solid black",
                                    borderRadius: "50px",
                                    cursor: "pointer",
                                    fontSize: "1.8rem",
                                }}
                                onClick={() => navigate('/how-it-works')}
                            >
                                Learn more about our data
                            </button> */}
                    </div>
                    <div className='text-from-vid-container right anim-right'>
                        <h1 className='h1-section'>Up to Date Relative Value </h1>
                        <div className = "line"></div>
                        <p><b>
                            Discover current hidden relations. Our platform constantly looks for statistical relations. It is also transparent, with our signals sourced and explained, meaning that your firm gains a deep understanding of the market relations without sifting through noise for days.
                        </b></p>
                        {/* <button
                                style={{
                                    padding: "0.75rem 1.5rem",
                                    color: "black",
                                    border: "2px solid black",
                                    borderRadius: "50px",
                                    cursor: "pointer",
                                    fontSize: "1.8rem",
                                }}
                                onClick={() => navigate('/how-it-works')}
                            >
                                Learn more about our partnered brokers
                            </button> */}
                    </div>
                    <div className = 'cropped-vid-container'>
                        <img alt="" src="/images/NEWSMB.gif" />
                    </div>
                    <div className = 'cropped-vid-container right'>
                        <img alt="" src="/images/Popupnew-noBackground.png" />
                        <p style={{ fontWeight: "400" }}>PNL charts provide actual results based on historical predictions and performance.</p>
                    </div>
                    <div className='text-from-vid-container left'>
                        <h1 className='h1-section'>Unique Alpha Research</h1>
                        <div className = "line"></div>
                        <p><b>
                            Incorporate your insights and play with scenarios. Our models use expandable context windows and enable you to perform sensitivity analyses. You can even incorporate your proprietary alternative data, your client's needs and wants, or even your gut feelings about the market
                        </b></p>
                        {/* <button
                                style={{
                                    padding: "0.75rem 1.5rem",
                                    color: "black",
                                    border: "2px solid black",
                                    borderRadius: "50px",
                                    cursor: "pointer",
                                    fontSize: "1.8rem",
                                }}
                                onClick={() => navigate('/company')}
                            >
                                Learn more about fAlpha's mission
                            </button> */}
                    </div>
                    <div style = {{ height: "100px" }}></div>  {/* Empty saving space for the 100px Y movement of the effect */}
                    {/* <div>
                        <h1>Gain Your Edge</h1>
                        <h3>
                            Whether you have access to proprietary numbers for a private company, a unique alternative data source essential to your fund's performance, or just have a gut feeling that you think should be incorporated, fAlpha combines your custom data with our comprehensive dataset and signals so that you can gain your edge on the market.
                        </h3>
                        <button
                                style={{
                                    padding: "0.75rem 1.5rem",
                                    color: "black",
                                    border: "2px solid black",
                                    borderRadius: "50px",
                                    cursor: "pointer",
                                    fontSize: "1.8rem",
                                }}
                                onClick={() => navigate('/how-it-works')}
                            >
                                Learn more about our enterprise solutions
                            </button>
                    </div>
                    <div>
                        <img alt="" width="100" height="550" src="images/settings_newest.png" />
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export function HomeOnboardingSection() {

    const [fname, setFName] = useState("");
    const [lname, setLName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [response, setResponse] = useState("");

    let handleSubmit = async (e) => {
        e.preventDefault();
        if (!fname) {
            setResponse("First name required to submit");
            return;
        }
        if (!lname) {
            setResponse("Last name required to submit");
            return;
        }
        if (!email) {
            setResponse("Email required to submit");
            return;
        }
        const validateEmail = (em) => {
            return String(em)
                .toLowerCase().match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        };
        if (!validateEmail(email)) {
            setResponse("Valid email required to submit");
            return;
        }
        /*let token = captchaRef.current.getValue();
        if (!token) {
            setResponse("Recaptcha required to submit");
            return;
        }*/
        try {
            let res = await fetch("/api/public/contact", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: {
                        first: fname,
                        last: lname,
                    },
                    email: email,
                    message: message,
                    //captcha: token
                }),
            });
            //captchaRef.current.reset();
            if (res.status === 200) {
                setFName("");
                setLName("");
                setEmail("");
                setMessage("");
                setResponse("Message sent successfully");
            } else if (res.status === 403 || res.status === "403") {
                setResponse("Message error: please write in English and do not include links");
            } else {
                setResponse("Some error occurred");
                console.log("not here");
            }
        } catch (err) {
            console.log(err);
        }
    };

    function handleKeyDown(e) {
        e.target.style.height = 'inherit';
        e.target.style.height = `${Math.min(e.target.scrollHeight - 20, 116)}px`;
    }

    return (
        <div className="home-onboarding-section">
            <div className="home-onboarding-text" style={{ color: "black" }}>
                <h3 className="home-onboarding-h3" style={{ color: "black" }}>Join the thousands of asset managers, investment bankers, and traders on the waitlist today.</h3>
            </div>
            <form className="home-onboarding-form" style={{ color: "black" }}>
                <h2 className="home-onboarding-h2" style={{ color: "black" }}>Join the Waitlist</h2>
                <label htmlFor="fname">First Name</label>
                <input type="text" value={fname} id="fname" onChange={(e) => setFName(e.target.value)} />
                <label htmlFor="lname">Last Name</label>
                <input type="text" value={lname} id="lname" onChange={(e) => setLName(e.target.value)} />
                <label htmlFor="email">Email</label>
                <input type="text" value={email} id="email" onChange={(e) => setEmail(e.target.value)} />
                <label htmlFor="message">Message</label>
                <textarea rows="1" name="text" value={message} id="message" placeholder="optional" onChange={(e) => setMessage(e.target.value)} onKeyDown={handleKeyDown} />
                {/*<div className="home-onboarding-recaptcha">{recaptchaSiteKey ? <ReCAPTCHA sitekey={recaptchaSiteKey} ref={captchaRef} /> : null}</div>*/}
                <button onClick={handleSubmit}>Submit</button>
                <div className="message">{response ? <p>{response}</p> : null}</div>
            </form>
        </div>
    );

}

const Typewriter = ({ text, delay }) => {
    const [currentText, setCurrentText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        let timeout;
        if (currentIndex < text.length) {
            timeout = setTimeout(() => {
                setCurrentText(prevText => prevText + text[currentIndex]);
                setCurrentIndex(prevIndex => prevIndex + 1);
            }, delay);
        }
        return () => clearTimeout(timeout);
    }, [currentIndex, delay, text]);
    return <span>{currentText}</span>;
};

export function HomeCardTemplate(props) {
    const [cardState, setCardState] = useState(false);
    const pRef = useRef(null);

    const Trigger = () => {
        if (!cardState){
            setCardState(true);
            pRef.current.style.height = 'fit-content';
        } else {
            setCardState(false);
            pRef.current.style.height = '60px';
        }
    }
    useEffect(() => {
        if (props.triggered) {
            pRef.current.style.height = 'fit-content';
        }
    }, []);

    return (
        <div className="home-card" onClick={Trigger}>
            <h3 className="home-card-h3">{props.title}</h3>
            <p ref={pRef} className="home-card-p">{props.shown} {props.hidden}</p>
            {props.triggered || cardState ? null : <button onClick={Trigger} style={{ border: "none" }}>Learn more</button>}
        </div>
    )
}

export function HomeCardsSection() {
    return (
        <div className="home-card-container">
            <HomeCardTemplate
                title="A New Way for Worldclass Traders"
                shown="Traders have always needed unique, quantifiable, and reliable alpha to succeed. But with digital sources the game has gotten tougher."
                hidden="Alpha uniqueness is key even in non-zero-sum game market situations. It must allow traders to generate profits not easily replicated by others. On the other hand, risk management is about quantifying and acting in markets. This requires having sound and flexible statistical models. But that is not enough, data reliability is essential. Traders need to be able to trust their data. That is, traders should not use black boxes. Instead they should only rely on data that is verifiable and transparent. Doing this with outside data providers is revolutionary especially in this day of generative AI."
            />
            <HomeCardTemplate
                title="Quantifiable and Verifiable Alpha"
                shown="Quantification and verification are two sides of the same coin. fAlpha constantly calculates trading signals, confidence levels of its large sets of data, then it backtests its statistical summaries (ex ante and ex post)."
                hidden="And, to make YOU (the data user) comfortable and confident, fAlpha releases the performance of its statistical predictions. Its sources and historical sets are not only made available to YOU, they are intrinsic to fAlpha's ongoing product. This keeps us focused on our truth telling mission. That is, fAlpha goes beyond a “we stand by our data” rhetoric. We even guarantee some users' with their money back (depending the account settings). "
            />
            <HomeCardTemplate
                title="Traders and Analysts Use Cases"
                shown="Risk takers and analysts focused on corporate names use fAlpha's platform and/or its PRA to make more accurate, faster and reliable decisions. In a few seconds they gain insights on potentially hidden digital data."
                hidden="Traders get buy/sell signals, associated confidence levels, and various sentiment dimensions current and historical. For instance, they can check current and historical risk metrics, and accurately perform what if analyses. They can also create relative value groups, and get insights about corporates with similar behaviors. Analysts can also download and check historical data sets. They can mix those with their own other time series and even train their models with fAlpha's sentiment scores. Both traders and analysts can keep their stakeholders easily and automatically in the loop."
            />
            <HomeCardTemplate
                title="Context and Investment Signals"
                shown="Markets can move mostly in one direction but even in those cases some names lag. While there is always a reason time is of the essence. And since it is about YOUR alpha. YOUR concerns may differ from others."
                hidden="For instance, you may want to optimize some macro economic factor or view. fAlpha machines help you spot checking historical results. Its proprietary indicators identify market opportunities that are imperceptible to the naked eye. Plus it makes it easy for your eyes only. fAlpha helps you get ahead of the market and make smarter investment decisions right away."
            />
            <HomeCardTemplate
                title="How  Uses AI and LLMs"
                shown="fAlpha uses backpropagation to train several of its signals, it also uses large language models (LLMs) to communicate with its proprietary database."
                hidden="However, fAlpha is not a generative AI tech company, so it does not run the risk of producing unverifiable data or hallucinations around its signals. fAlpha delivers its data through a variety of forms, including a dashboard, a mobile app, an API, and Simple Storage Service (S3)."
            />
            <HomeCardTemplate
                title="Why fAlpha"
                shown="fAlpha was founded to help bring operational efficiencies to the corporate trading markets. Some of its founders lived through those inefficiencies (as users and producers) and know fixing is within reach."
                hidden="fAlpha's goal is to reduce market noise, especially in the one associated with digital data sets. More than being confident about its data and models, fAlpha is accountable to it outcomes. Regardless if the outcomes agree with fAlpha's initial predictions it displays them.  fAlpha will even issue partial refunds when the overall statistical results are off. There are reasons for fAlpha to be trusted by world-renowned institutions. Request special access through our contact form above."
            />
        </div>
    );
}

export function HomePageChatOnly() {
    const navigate = useNavigate();

    function handleQuestion(question) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ question: question }),
        };
        fetch('/api/public/create-chat', requestOptions)
            .then(response => response.json())
            .then(uuid => navigate(`/demo/par/${uuid}/${encodeURIComponent(question)}`));
    }

    const [exampleCompany1, setExampleCompany1] = useState(null);
    const [exampleCompany2, setExampleCompany2] = useState(null);

    function setUpExamples() {
        const companies = [
            "The Bancorp Inc",
            "Healthcare Services Group Inc",
            "Fisker Inc",
            "Stem Inc",
            "Global Industrial Co",
            "Express Inc",
            "American Eagle Outfitters Inc",
            "Microstrategy Inc",
            "ImmunityBio Inc",
            "Proterra Inc",
            "Meta",
            "Amazon",
            "Walmart",
            "Fortinet Inc",
            "Qualcomm",
            "Pfizer Inc",
            "Moderna Inc",
            "Nordstrom Inc",
            //"Under Armour Inc", // Disabled for ticker ambiguity reasons
            "Avis Budget Group Inc",
            "Post Holdings Inc",
            "Southwestern Energy Co"
        ];
        const shuffled = companies.sort(() => 0.5 - Math.random());
        let selected = shuffled.slice(0, 2);
        setExampleCompany1(selected[0]);
        setExampleCompany2(selected[1]);
    }

    function example1() {
        handleQuestion(encodeURIComponent(`What is the current news sentiment towards ${exampleCompany1}? Include sources.`));
    }

    function example2() {
        handleQuestion(encodeURIComponent(`I'm looking at ${exampleCompany2}, what other companies should I look into?`));
    }

    const [input, setInput] = useState("");

    let selfSubmit = async (e) => {
        e.preventDefault();
        handleQuestion(encodeURIComponent(input));
        setInput("");
    }

    function isLikelyUUID(str) {
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return uuidRegex.test(str);
    }

    var displayHeaderUUID = null;

    function initializeUUID() {
        // detect and display header
        if (localStorage) {
            const localuuid = localStorage.getItem("lastChat");
            if (isLikelyUUID(localuuid)) {
                displayHeaderUUID = localuuid;
                return;
            }
        }
        if (sessionStorage) {
            const sessionuuid = sessionStorage.getItem("lastChat");
            if (isLikelyUUID(sessionuuid)) {
                displayHeaderUUID = sessionuuid;
                return;
            }
        }
    }

    const homePageTyped = useRef(null);

    useEffect(() => {
        initializeUUID();
        setUpExamples();
    }, []);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // return (
    //     <div>
    //         <div className="home-background" style={{ color: "var(--navy)" }}>
    //             <div style={{ zIndex: "5", marginBottom: "60px" }} className="home-headline">
    //                 <h1 style={{ textAlign: "left" }}>Meet <span className="orange">Alice</span>, your AI-assistant to easily access fAlpha's insights<span style={{ fontSize: "1rem" }}>(BETA)</span></h1>
    //             </div>
    //             <div className="home-chatbox" style={{ zIndex: "5" }}>
    //                 <div className="home-capabilities-row">
    //                     <button onClick={example1} className="home-capabilities-button">What is the current news sentiment towards {exampleCompany1}? Include sources.</button>
    //                     <button onClick={example2} className="home-capabilities-button">I'm looking at {exampleCompany2}, what other companies should I look into?</button>
    //                 </div>
    //                 {/* Different sizing on mobile vs. desktop */}
    //                 <form id={isMobile ? "home-chat-form-mobile" : "home-chat-form"}>
    //                     <input id={isMobile ? "home-chat-input-mobile" : "home-chat-input"}
    //                         type="text"
    //                         placeholder="Ask me about corporate credit trading..."
    //                         value={input}
    //                         onChange={(e) => setInput(e.target.value)} />
    //                     <button onClick={selfSubmit}
    //                         id={isMobile ? "home-chat-submit-mobile" : "home-chat-submit"}
    //                         style={{ boxShadow: "none" }}>
    //                         <img className={isMobile ? "home-chat-submit-icon-mobile" : "home-chat-submit-icon"}
    //                             src="/images/submit-button.png" alt="submit question" />
    //                     </button>
    //                 </form>
    //             </div>
    //         </div>
    //     </div>
    // );
}

function Testimonial({ name, description, text, image }) {
    return (
        <div className='testimonial'>
            <img src={image} alt={`${name}`} className='testimonial-image' />
            <div className='testimonial-content'>
                <p className='text'>"{text}"</p>
                <h3>{name}</h3>
                <p className='description'><i>{description}</i></p>
            </div>
        </div>
    )
}

function HomeTestimonialsSection() {
    return (
        <div className='home-testimonial-card'>
            <h1>What Industry and Academic Experts Say</h1>
            <Carousel autoPlay indicators swipe cycleNavigation fullHeightHover animation="slide">
                <Testimonial
                    text="fAlpha.ai has distinguished itself within the crowded field of market data providers. Its state-of-the-art financial AI and machine learning models and dedicated research team ensure the accuracy of the confidence levels displayed. I am also impressed with fAlpha's transparency, including acknowledging errors. These strengths will allow it to compete effectively with much larger players in the space."
                    name="Bruce Petersen"
                    description="Trader, quantitative strategist and risk manager FICC (rates and credit), Retired from Goldman Sachs"
                    image="images/id_photos/brucepeterson.png"
                />
                <Testimonial
                    text="fAlpha is a beacon in the vast landscape of market data providers, where many offerings are simply noise. This can be largely attributed to fAlpha's team, and in particular the visionary leadership of CEO Geraldo Filgueiras. The firm's cutting-edge ML technology offers robust and transparent corporate market insights, delivered with statistical confidence levels that quantify forecast uncertainty. This sets them apart from other providers in a competitive sector where some players spend as much as $15 billion annually on data and technology."
                    image="images/id_photos/kaygiesecke.png"
                    name="Kay Giesecke"
                    description="Professor of Engineering and Director of Advanced FinTech Lab and Comp Finance, Stanford University"
                />
            </Carousel>
        </div>
    )
}

export function HomePageAnimation(props) {

    if (props.topHalf) {
        return (
            <div style={{ overflow: "hidden", height: "300px" }}>
                <div style={{ position: "relative", height: "600px" }} className={props.darkBenchmark ? "truecolor" : ""}>
                    <div className="home-page-gear-chart-container">
                        <div style={{
                            borderTop: "2px solid #3E6A96",
                            borderBottom: "2px solid #3E6A96",
                            height: "calc(100% - 100px)",
                            marginTop: "50px"
                        }}>
                            <D3DynamicLine data={null} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div style={{ position: "relative", height: "fit-content", maxWidth: "90vh", overflow: "hidden" }} className={props.darkBenchmark ? "truecolor" : ""}>

            <div className="home-page-gear-chart-container">
                <div style={{
                    borderTop: "2px solid #3E6A96",
                    borderBottom: "2px solid #3E6A96",
                    height: "calc(100% - 100px)",
                    marginTop: "50px"
                }}>
                    <D3DynamicLine data={null} />
                </div>
            </div>
            <img src="/images/home-page-animation-back-new2.png" alt="" width="100%" />
            <img src="/images/front-gear-spinner.png" alt="" width="33.5%" className="home-page-gear-new-spin" />
            {
                props.darkBenchmark &&
                <div style={{
                    backgroundColor: "var(--lightsteelblue)",
                    position: "absolute",
                    top: "5%",
                    left: "12%",
                    height: "3.5%",
                    width: "18.5%",
                    zIndex: -1,
                    borderRadius: "3px"
                }}></div>
            }
        </div>
    )
}

function HomePageMainNew() {
    const homePageTyped = useRef(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    useEffect(() => {
        if (homePageTyped.current) {
            const typed = new Typed(homePageTyped.current, {
                strings: [ /* old orange: #FF820E*/
                    "<span style='color:var(--blue-font)'>trading opportunities</span>",
                    "<span style='color:var(--blue-font)'>financial risks</span>",
                    "<span style='color:var(--blue-font)'>portfolio optimizations</span>"
                ],
                startDelay: 100,
                typeSpeed: 70,
                backSpeed: 0,
                backDelay: 1000,
                loop: true,
                loopCount: Infinity,
            });

            return () => {
                typed.destroy();
            };
        }

    }, []);

    const navigate = useNavigate();

    return (
        <div>
            <PublicNavbar />
            <GradientAnimation class="home-background-canvas" />
            <div className="home-background">
                <div className="home-headline" >
                    <div style={{ width: isMobile ? "100%" : "50%", float: "left", paddingTop: "5vh", overflowX: "visible", color: "var(--dark-font)" }}>
                        {/*
                            ((new Date().getDate()) % 4 < 2) ?
                                (
                                    ((new Date().getDate()) % 4 == 0) ?
                                        <h1 className="home-h1 home-h1-t3"><em>The</em> Trading Data Engine for Agile Investors to Optimize<strong> Your Risk-Return Performance</strong><strong style={{ color: 'var(--orange)' }}>.</strong></h1>
                                        :
                                        <h1 className="home-h1 home-h1-t3">For Traders Like You Who Value Due <strong>Diligence First</strong><strong style={{ color: 'var(--orange)' }}>.</strong></h1>
                                )
                                :
                                (
                                    ((new Date().getDate()) % 4 == 3) ?
                                        <h1 className="home-h1 home-h1-t3"><em>The</em> Ultimate Risk Assistant for <strong><em>Credit and Equity</em></strong> Trading to Grow Your Business<strong style={{ color: 'var(--orange)' }}>.</strong></h1>
                                        :
                                        <h1 className="home-h1 home-h1-t3">Premier AI-Driven <strong>Top Risk Management</strong> for Your Trading<strong style={{ color: 'var(--orange)' }}>.</strong></h1>
                                )
                        */}
                        <h1 className="home-h1" style={{ fontFamily: "'Inter', sans-serif", color: 'gray',fontSize: "2.4rem" }}>
                            <em>
                            <strong style={{ color: 'black' }}>Customizable</strong> AI-Powered Trading 
                            </em>
                            <br />
                            <span style={{ fontWeight: 'bold' }}> <strong style={{ color: 'black' }}> Edge</strong> for Investment Managers</span>
                        </h1>


                        <br />
                        <p style={{ textAlign: "left", fontSize: "1.0rem", fontFamily: "'Inter', sans-serif" }}>
                            <strong>Agentic AI, customizable to trading strategies, delivers reasoning, confidence levels, and optimal context windows, enabling traders to manage risk effectively.</strong>
                        </p>
                        <br />  

                        <br />
                        <div className="home-buttons-container">
                            <button className='home-button'
                                onClick={() => {
                                    window.scrollTo({
                                        top: document.body.scrollHeight,
                                        behavior: "smooth",
                                    });
                                }}
                            >
                                Join the Waitlist
                            </button>
                            <button className='home-button'
                                onClick={() => navigate('/contact')}
                            >
                                Request a Demo
                            </button>
                            <button className='home-button'
                                onClick={() => navigate("/how-it-works", { state: { pageState: "tradingpulse" } })}
                            >
                                    How It Works
                            </button>
                        </div>

                    </div>

                    {!isMobile &&
                        <div className="home-main-right-container">
                            <img className="cropped-vid" alt="" src="/images/NEWTP.gif" width="100%" height="100%" /> 
                        </div>
                    }
                </div>
                <div style={{ position: "absolute", bottom: "0", left: "50%", transform: "translate(-50%, 0)" }}>
                    <svg className="arrows">
                        <path className="a1" d="M0 0 L30 32 L60 0"></path>
                        <path className="a2" d="M0 20 L30 52 L60 20"></path>
                        <path className="a3" d="M0 40 L30 72 L60 40"></path>
                    </svg>
                </div>
            </div>
        </div>

    );
}


export default function Home() {
    let location = useLocation();

    const [installPrompt, setInstallPrompt] = useState(null);

    window.addEventListener("beforeinstallprompt", (event) => {
        event.preventDefault();
        setInstallPrompt(event);
    });

    window.document.title = "fAlpha.ai | Home";

    const [showDiv, setShowDiv] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            if (scrollPosition > 1) {
                setShowDiv(true);
            } else {
                setShowDiv(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        // Dynamically add the script to the page
        const script = document.createElement("script");
        script.src = "https://js-na2.hsforms.net/forms/embed/242535441.js";
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup script on unmount
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            {showDiv && <div className='home-tmp-navbar'><PublicNavbar /></div>}
            <ScrollToHashElement />
            <div className="particle-background">
                <ParticleBackground />
            </div>
            <Routes location={location}>
                <Route path="/" element={<HomePageMainNew />} />
                {/*<Route path="/demo" element={<HomePageMain />} />*/}
                <Route path="/demo/par/" element={<AliceChat installPrompt={installPrompt} />} />
                <Route path="/demo/par/:id/:question?" element={<AliceChat installPrompt={installPrompt} />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <br></br>
            <br></br>
            <HomeSourcesSection />
            <br></br>
            <br></br>
            <HomeStatisticsSection />
            <br></br>
            <HomePagesDisplay />
            <HomeTestimonialsSection />
            <Routes location={location}>
                <Route path="/" element={<HomePageChatOnly />} />
            </Routes>
            {/* <HomeCardsSection /> */}
            <br></br>
            <br></br>
            <span id="contact-us"></span>
            <div
                className="hs-form-frame"
                data-region="na1"
                data-form-id="d22a55d6-8269-4342-8795-c093fbaed896"
                data-portal-id="48174566"
            ></div>
            <PublicFooter />
        </>
    );
}
